<template>
    <facility-and-project-main-container>
        <template #title>
            Facility admin
        </template>
        <template #controls>
            <create-new-button

                button-text="Create new facility"
                library-name="Facility"
                @onClick="newFacility" />
        </template>
        <template #new>
            <router-view
                :code-set-name="codeSetName"
                title="Create a new facility"
                library="Facility"
                @onRefresh="refreshFacilities"
                @onCancel="cancelNew" />
        </template>
        <template #facility>
            <b-table
                :loading="loading"
                :data="facilityList.data"
                default-sort="Name"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                class="site-sticky-header">
                <b-table-column
                    v-slot="props"
                    field="Name"
                    label="Name"
                    sortable>
                    <router-link :to="getFacilityLink(props.row)">
                        {{ props.row.Name }}
                    </router-link>
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="ParentFacility"
                    label="Parent"
                    sortable>
                    {{ props.row.ParentFacility }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="Description"
                    label="Description"
                    sortable>
                    {{ props.row.Description }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="StartupDate"
                    label="Startup date"
                    sortable>
                    {{ shortDate(props.row.StartupDate) }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="SAPPlant"
                    label="SAP Plant no."
                    sortable>
                    {{ props.row.SAPPlant }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="NPDID"
                    label="NPD Id"
                    sortable>
                    {{ props.row.NPDID }}
                </b-table-column>
            </b-table>
        </template>
    </facility-and-project-main-container>
</template>

<script>
    import { genericViewQueryAsText, getCodeSets } from '@/shared/helpers/api';
    import { requireCanEditCode } from '@/shared/directives/requirePermission';
    import { encodeIdBase64 } from '@/shared/helpers/utils';
    import ViewBaseFacilityAndProject from '@/apps/facilityAndProject/ViewBaseFacilityAndProject.vue';
    import CreateNewButton from '@/apps/facilityAndProject/CreateNewButton.vue';
    import { shortDate } from '@/formatters.ts';

    export default {
        directives: {
            'require-can-edit-code': requireCanEditCode
        },
        components: {
            CreateNewButton,
            FacilityAndProjectMainContainer: ViewBaseFacilityAndProject
        },
        data() {
            return {
                loading: true,
                facilityList: {},
                codeSetName: null,
                facilityQuery: `
                    FROM Facility
                    SELECT Id, Name, Description, ParentFacility, SAPPlant, NPDID, StartupDate
                    WHERE IsValid=true`
            };
        },
        async mounted() {
            this.facilityList = await genericViewQueryAsText(this, this.facilityQuery);
            this.codeSetName = (await getCodeSets(this, 'Facility'))[0].name;
            this.loading = false;
        },
        methods: {
            shortDate,
            newFacility() {
                this.$router.push({ name: 'CreateNewFacility' });
            },
            cancelNew() {
                this.$router.push({ name: 'FacilityList' });
            },
            async refreshFacilities() {
                this.$router.push({ name: 'FacilityList' });
                this.facilityList = await genericViewQueryAsText(this, this.facilityQuery);
            },
            getFacilityLink(f) {
                return { name: 'FacilityById', params: { id: encodeIdBase64('Code', f.Id) } };
            }
        }
    };
</script>
